import * as React from 'react';
import { smoothScrollIntoView, useIsDesktop } from '@cian/valuation-utils-component';
import { StickyScrollBtnContainer, useToggleStickyScrollBtn } from '../StickyScrollBtn';
import { HeroBannerLayout, HeroBannerMobile } from '../../components/HeroBanner';
import { AddNewCardLayout } from '../../components/AddNewCard';
import { FormAnnotationContainer } from '../FormAnnotationContainer';
import { MyHomeFormContainer } from '../MyHomeFormMicrofrontend';
import { FiltersMobileContainer } from '../FiltersContainer';
import { PageLayout } from '../../components/PageLayout';
import { Advantages } from '../../components/Advantages';
import { ServiceCardsContainer } from '../ServiceCards';
import { HomeProfitOnboardingContainer, NewDreamOnboardingContainer } from '../Onboarding';
import { useSaveSource } from 'shared/hooks';

export const PageContainer: React.FC = () => {
  useSaveSource();
  const isDesktop = useIsDesktop();

  const containerRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(containerRef);

  const scrollToFilters = React.useCallback(() => {
    smoothScrollIntoView(containerRef.current as HTMLDivElement);
  }, []);

  return (
    <>
      {isDesktop ? (
        <HeroBannerLayout>
          <AddNewCardLayout containerRef={containerRef} annotation={<FormAnnotationContainer />}>
            <MyHomeFormContainer />
          </AddNewCardLayout>
        </HeroBannerLayout>
      ) : (
        <>
          <HeroBannerMobile containerRef={containerRef} />
          <FiltersMobileContainer />
        </>
      )}

      <div data-testid="PageContainer">
        <PageLayout>
          <Advantages />
          <ServiceCardsContainer />
        </PageLayout>
      </div>

      <StickyScrollBtnContainer action={scrollToFilters} />

      <NewDreamOnboardingContainer onFinishClick={scrollToFilters} />
      <HomeProfitOnboardingContainer onFinishClick={scrollToFilters} />
    </>
  );
};
